import React from 'react';
import { Typography } from '@mui/material';
import type { EngagementEngine } from '../../../hooks/advisory/advisoryEngine';
import { useUntypedTranslation } from '../../../hooks/useUntypedTranslation';
import { meta } from '../../../styles/visualLanguage';

export function AdvisoryEngineLabel({ engine }: { engine?: EngagementEngine }) {
  const { t } = useUntypedTranslation();
  if (!engine) return null;
  return (
    <Typography data-testid="advisory-engine-label" sx={[meta, { my: 2 }]}>
      {t('advisory:engine.selected', {
        engine: t(engine === 'astra' ? 'advisory:engine.astra' : 'advisory:engine.v3'),
      })}
    </Typography>
  );
}
